import axios from "axios";
import { API_URL } from "../config";
import { APP_BASENAME, paths } from "../paths";

export const caApi = axios.create({
  baseURL: API_URL,
});

caApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

caApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      window.location.href = `${APP_BASENAME}${paths.login}`;
    }
    return Promise.reject(error);
  }
);
